export default (function () {

  /**
   * CTA Fixed
   *
   */
  if (document.querySelector('.js-cta-fixed') != undefined && document.querySelector('.js-cta-fixed') != null) {

    document.querySelector('.c-cta-fixed__close').addEventListener('click', (e) => {
      document.querySelector('.js-cta-fixed').remove();
    });
  }

})();
